export const CONFIRMATION_INITIATED = 'CONFIRMATION_INITIATED';
export const ACTION_CONFIRMED = 'ACTION_CONFIRMED';
export const ACTION_CANCELLED = 'ACTION_CANCELLED';
